"use strict";

(function ($, Drupal, window, document) {
  // OnReady
  $(function () {
    $('.burger-main-menu-icon').click(function (event) {
      $('#navigation').slideToggle();
    });
    $('#sidebar-second nav.navigation h2').each(function (index) {
      $nav_header = $(this);
      $nav_block = $nav_header.parent();
      $nav_header.click(function (event) {
        $nav_header.toggleClass('opened');
        $nav_block.children("ul").slideToggle();
      });
      $nav_block.find('.item--expanded:not(.active)').click(toggleChildMenu);
    });
    $('#block-barents-main-menu .menu-item--expanded').click(toggleChildMenu);
    $('#block-barents-nav-links .barents-lang-switcher').each(function () {
      var $block = $(this).children('.content');
      var $list = $block.children('ul');
      var $active = $list.find('li.is-active');

      if ($active.length <= 0) {
        $active = $list.find('li:first-child');
      }

      $active.detach();
      var $toggler = $active.children('a').clone();
      $list.prepend($active);
      $toggler.attr('href', '#').addClass('swticher-toggler');
      $toggler.prependTo($block);
      $block.click(function () {
        $list.slideToggle('fast');
      });
    });
  });

  function toggleChildMenu(event, $parent) {
    // Passthrough clicks on link!
    if (event.target != this) {
      return true;
    }

    $(this).children('ul').slideToggle();
    this.classList.toggle('opened');
  }
})(jQuery, Drupal, window);